import React, { Component } from 'react';

import {RightColumn} from "../../Common/pages/RightColumn";
import {StandardPage} from "../../Common/pages/StandardPage";
import PropTypes from "prop-types";

export default class FootballMatchCentreLayout extends Component {

  static propTypes = {
    location: PropTypes.object.isRequired,
    FootballLiveMatchContainer: PropTypes.element.isRequired,
  };

  render() {
    const {
      FootballLiveMatchContainer,
      location
    } = this.props;

    return (
      <StandardPage sport="football" title="Live Scores" >
        <div className="main-layout-left-column">
         {FootballLiveMatchContainer}
        </div>

        <RightColumn location={location}
                     sport="football"
                     content={["topMpu", "ocWidget"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballMatchCentreLayout.js